import React from "react";
import { View, Text } from "@react-pdf/renderer";
import InsuranceAndDocumentDetailsStyles from "../Styles";
import { LabelLineRow } from "./FormFields";

const InsuranceAndDocumentDetails = ({ primaryColor = "081e56", logo = "", tradingName, regulatoryText, userEmail, userName }) => {
  const styles = InsuranceAndDocumentDetailsStyles(primaryColor);

  return (
    <View style={{ ...styles.FlexStartColumn, gap: 0 }}>
      <Text style={styles.ContentSemiBold}>Insurance and Document Details</Text>
      <View style={styles.panel}>
        <View style={styles.cols}>
          {/* Row 1 */}
          <View style={styles.row}>
            <View style={styles.col}>
              <Text style={styles.LabelSmallSemiBold}>Car Insurance with</Text>
              <LabelLineRow styles={styles} label="Car Reg No." />
              <LabelLineRow styles={styles} label="Make" />
              <LabelLineRow styles={styles} label="Address" lines={2} />
              <LabelLineRow styles={styles} label="Tel No." />
              <LabelLineRow styles={styles} label="Policy" />
            </View>

            <View style={styles.col}>
              <View style={styles.homeTitleRow}>
                <Text style={styles.LabelSmallSemiBold}>
                  Home - Mortgage with (building society, bank etc.)
                </Text>
              </View>

              <LabelLineRow styles={styles} label="Address" lines={2} />
              <LabelLineRow styles={styles} label="Tel No." />
              <LabelLineRow styles={styles} label="Mortgage Ref No." />
              <LabelLineRow styles={styles} label="The Deeds are With" />
            </View>
          </View>

          {/* Row 2 */}
          <View style={styles.row}>
            <View style={styles.col}>
              <Text style={styles.LabelSmallSemiBold}>
                Building Insurance with
              </Text>
              <LabelLineRow styles={styles} label="" />
              <LabelLineRow styles={styles} label="Address" lines={2} />
              <LabelLineRow styles={styles} label="Tel No." />
              <LabelLineRow styles={styles} label="Policy No." />
            </View>

            <View style={styles.col}>
              <Text style={styles.LabelSmallSemiBold}>
                Contents Insurance With
              </Text>
              <LabelLineRow styles={styles} label="" />
              <LabelLineRow styles={styles} label="Address" lines={2} />
              <LabelLineRow styles={styles} label="Tel No." />
              <LabelLineRow styles={styles} label="Policy No." />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default InsuranceAndDocumentDetails;
